/* eslint-disable */

import autosize from 'autosize'

const $ = window.$

window.debounce = function (func, wait, immediate) {
  let timeout
  return function () {
    const context = this
    const args = arguments
    const later = function () {
      timeout = null
      if (!immediate) func.apply(context, args)
    }
    const callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
    if (callNow) func.apply(context, args)
  }
}

// This function will round up to a nice looking number
window.roundrate = function (rate, round) {
  if (!round) {
    if (rate > 1000) {
      var round = 50
    } else if (rate > 350) {
      var round = 25
    } else if (rate > 225) {
      var round = 10
    } else {
      var round = 5
    }
  }
  rate /= round
  rate = Math.ceil(rate)
  rate *= round
  return rate
}

// Stripping HTML tags from string
window.strip_tags = function (input, allowed) {
  allowed = (`${allowed || ''}`.toLowerCase().match(/<[a-z][a-z0-9]*>/g) || []).join('') // making sure the allowed arg is a string containing only tags in lowercase (<a><b><c>)
  const tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi
  const commentsAndPhpTags = /<!--[\s\S]*?-->|<\?(?:php)?[\s\S]*?\?>/gi
  return input
    .replace(commentsAndPhpTags, '')
    .replace(tags, ($0, $1) => (allowed.indexOf(`<${$1.toLowerCase()}>`) > -1 ? $0 : ''))
}

$(() => {
  $('body').on('click', '.payment-modalopen', function () {
    const bill_id = $(this).data('billid')
    const redirectUri = $(this).data('redirecturi')
    let formUrl = `/payments/create?bill_id=${bill_id}`
    if (redirectUri !== undefined) {
      formUrl = `${formUrl}&redirect_uri=${redirectUri}`
    }
    $('#paymentmodal-content').html('') // TODO: Add spinner
    $('#paymentmodal-content').load(formUrl, (responseText, textStatus, req) => {
      if (textStatus == 'error') {
        $('#paymentmodal-content').html(
          `<div class="modal-content">${$t('Error in loading bill')}</div>`,
        )
      }
    })
    $('#paymentmodal').modal({ backdrop: 'static', keyboard: false }, 'show')
  })
})

$(() => {
  $('body').on('click', '.offer-modalopen', function () {
    const offerid = $(this).data('offerid')
    $('#accept-offer-content').html('') // TODO: Add spinner
    $('#accept-offer-content').load(
      `/offer/${offerid}/hires/create`,
      (responseText, textStatus, req) => {
        if (textStatus == 'error') {
          $('#accept-offer-content').html(
            `<div class="modal-content">${$t('Error in loading offer')}</div>`,
          )
        }
      },
    )
    $('#accept-offer').modal('show')
  })

  $('body').on('click', '.contract-edit-modalopen', function () {
    const hireid = $(this).data('hireid')
    const state = $(this).data('contract-form-state')
    $('#contract-summary-modal-content').html('')
    $('#contract-edit-modal-content').html('')
    $('#contract-edit-modal-content').load(
      `/hires/${hireid}/edit`,
      (responseText, textStatus, req) => {
        if (textStatus == 'error') {
          $('#contract-edit-modal-content').html(
            `<div class="modal-content">${$t('Error in loading offer')}</div>`,
          )
        }
      },
    )
    $('#contract-edit-modal').modal('show')
  })

  $('body').on('click', '.contract-summary-modalopen', function () {
    const hireid = $(this).data('hireid')
    $('#contract-summary-modal-content').html('')
    $('#contract-edit-modal-content').html('')
    $('#contract-summary-modal-content').load(
      `/hires/${hireid}`,
      (responseText, textStatus, req) => {
        if (textStatus == 'error') {
          $('#contract-summary-modal-content').html(
            `<div class="modal-content">${$t('Error in loading offer')}</div>`,
          )
        }
      },
    )
    $('#contract-summary-modal').modal('show')
  })

  $('body').on('click', '.contract-approve-modalopen', function (event) {
    // sometimes this class is applied to elements inside a button, which can be disabled
    const isDisabled = event.currentTarget?.disabled || event.currentTarget?.parentNode?.disabled
    if (isDisabled) return false

    const hireid = $(this).data('hireid')
    $('#contract-summary-modal-content').html('')
    $('#contract-edit-modal-content').html('')
    $('#contract-summary-modal-content').load(
      `/hires/${hireid}/accept`,
      (responseText, textStatus, req) => {
        if (textStatus == 'error') {
          $('#contract-summary-modal-content').html(
            `<div class="modal-content">${$t('Error in loading offer')}</div>`,
          )
        }
      },
    )
    $('#contract-summary-modal').modal('show')
  })
})

$(() => {
  $('#logosearch-modal').on('shown.bs.modal', (e) => {
    $('#logosearch-modal-content').html(
      '<div class="modal-content"><div class="preloader pls-blue block-center" style="margin-top: 10%;margin-bottom: 10%;margin-left: 50%;left: -25px;"><svg class="pl-circular" viewBox="25 25 50 50"><circle class="plc-path" cx="50" cy="50" r="20"></circle></svg></div></div>',
    )
    $('#logosearch-modal-content').load('/profile/search-logo', (responseText, textStatus, req) => {
      if (textStatus == 'error') {
        $('#logosearch-modal-content').html(
          `<div class="modal-content"><div class="m-10 m-t-20 alert alert-warning">${$t(
            'An error occurred. Please try again',
          )}</div></div>`,
        )
      }
    })
  })
  $('#logosearch-modal').on('hidden.bs.modal', (e) => {
    $('#logosearch-modal-content').html('')
  })
})

/* Cookie interface for front end usage */
window.jQuery.cookie = function (key, value, options) {
  // key and at least value given, set cookie...
  if (arguments.length > 1 && String(value) !== '[object Object]') {
    options = jQuery.extend({}, options)

    if (value === null || value === undefined) {
      options.expires = -1
    }

    if (typeof options.expires === 'number') {
      const days = options.expires
      const t = (options.expires = new Date())
      t.setDate(t.getDate() + days)
    }

    value = String(value)

    const maxage = new Date()
    maxage.setDate(maxage.getDate() + 365)
    return (document.cookie = [
      encodeURIComponent(key),
      '=',
      options.raw ? value : encodeURIComponent(value),
      options.expires
        ? `; expires=${options.expires.toUTCString()}`
        : `; expires=${maxage.toUTCString()}`, // use expires attribute, max-age is not supported by IE
      options.path ? `; path=${options.path}` : '; path=/',
      options.domain ? `; domain=${options.domain}` : '',
      options.secure ? '; secure' : '',
    ].join(''))
  }

  // key and possibly options given, get cookie...
  options = value || {}
  let result
  const decode = options.raw
    ? function (s) {
        return s
      }
    : decodeURIComponent
  return (result = new RegExp(`(?:^|; )${encodeURIComponent(key)}=([^;]*)`).exec(document.cookie))
    ? decode(result[1])
    : null
}

// Used for typeahead
window.substringMatcher = function (strs) {
  return function findMatches(q, cb) {
    let matches
    let substrRegex

    // an array that will be populated with substring matches
    matches = []

    // regex used to determine if a string contains the substring `q`
    substrRegex = new RegExp(q, 'i')

    // iterate through the pool of strings and for any string that
    // contains the substring `q`, add it to the `matches` array
    $.each(strs, (i, str) => {
      if (substrRegex.test(str)) {
        matches.push(str)
      }
    })

    cb(matches)
  }
}

let lastAction = null

$('body').on('click', '.like-action', function () {
  let action = 'like'
  const modelid = $(this).data('modelid')
  const liketype = $(this).data('liketype')
  if ($(this).hasClass('liked')) {
    action = 'unlike'
  }

  if (lastAction === action) {
    return
  }
  lastAction = action

  const likebtn = $(this)
  $.ajax({
    method: 'POST',
    url: '/like',
    data: { type: liketype, id: modelid, action },
    dataType: 'json',
  }).done((data) => {
    if (data.status == 'ok') {
      if (data.liked) {
        $(likebtn)
          .removeClass('c-gray')
          .removeClass('notliked')
          .addClass('c-gray-900')
          .addClass('liked')
        $(likebtn)
          .find('.like-action-text')
          .text(function () {
            return $(this).data('likedtext')
          })
      } else {
        $(likebtn)
          .addClass('c-gray')
          .removeClass('c-gray-900')
          .removeClass('liked')
          .addClass('notliked')
        $(likebtn)
          .find('.like-action-text')
          .text(function () {
            return $(this).data('notlikedtext')
          })
      }
    }
  })
  $(this).blur()
  return false
})

$('body').on('click', '.flag-irrelevant', function () {
  let action = 'flag'
  const threadid = $(this).data('threadid')
  if ($(this).hasClass('flagged')) {
    action = 'unflag'
  }
  const btn = $(this)
  $.ajax({
    method: 'POST',
    url: '/flag',
    data: { id: threadid, action },
    dataType: 'json',
  }).done((data) => {
    if (data.status == 'ok') {
      if (data.flagged) {
        $(btn).removeClass('notflagged').addClass('flagged')
      } else {
        $(btn).removeClass('flagged').addClass('notflagged')
      }
    }
  })
  $(this).blur()
  return false
})

$('body').on('click', '.swal-delete', function () {
  swal_delete($(this))
  return false
})
window.swal_delete = function (link) {
  if ($(link).data('formid')) {
    var form = $(`#${$(link).data('formid')}`)
  } else {
    var form = $(link).parents('form')
  }
  window.swal(
    {
      title: $t('Are you sure?'),
      text: $(link).data('swaltext'),
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: $(link).data('swalconfirmtext')
        ? $(link).data('swalconfirmtext')
        : $t('Yes, delete'),
      cancelButtonText: $t('No, go back!'),
      closeOnConfirm: false,
    },
    () => {
      form.submit()
      window.swal(
        $t('Processing'),
        $(link).data('swalcompletedtext') ? $(link).data('swalcompletedtext') : $t('Now deleting'),
        'success',
      )
    },
  )
}

$('body').on('click', '.swal-creditnote', function () {
  swal_creditnote($(this))
  return false
})
window.swal_creditnote = function (link) {
  if ($(link).data('formid')) {
    var form = $(`#${$(link).data('formid')}`)
  } else {
    var form = $(link).parents('form')
  }
  window.swal(
    {
      title: $t('Are you sure?'),
      text: $(link).data('swaltext'),
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: $(link).data('swalconfirmtext')
        ? $(link).data('swalconfirmtext')
        : $t('Yes, create'),
      cancelButtonText: $t('No, go back!'),
      closeOnConfirm: false,
    },
    () => {
      form.submit()
      window.swal(
        'Making credit note',
        $(link).data('swalcompletedtext')
          ? $(link).data('swalcompletedtext')
          : $t('We are now creating a credit note'),
        'success',
      )
    },
  )
}

// Prevent multiple submits in forms
window.disableOnSubmit = function (form) {
  //  Add loading spinner
  const $btn = $(form).find('.single-click,input[type=submit],button[type=submit]').first()
  if ($btn.hasClass('button-with-spinner') || $btn.hasClass('no-spinner')) {
    return
  }
  const placeleft = $btn.parent().css('text-align') == 'right'
  const placeoutright = $btn.hasClass('btn-block')
  if (placeoutright) {
    $btn
      .parent()
      .append(
        '<div class="preloader pls-blue pls-topright"><svg class="pl-circular" viewBox="25 25 50 50"><circle class="plc-path" cx="50" cy="50" r="20"></circle></svg></div>',
      )
  } else if (placeleft) {
    $btn
      .parent()
      .prepend(
        '<div class="preloader pls-blue pls-left"><svg class="pl-circular" viewBox="25 25 50 50"><circle class="plc-path" cx="50" cy="50" r="20"></circle></svg></div>',
      )
  } else {
    $btn
      .parent()
      .append(
        '<div class="preloader pls-blue"><svg class="pl-circular" viewBox="25 25 50 50"><circle class="plc-path" cx="50" cy="50" r="20"></circle></svg></div>',
      )
  }

  // Disabled the submit btn to avoid multiple submits
  $(form).find('.single-click,input[type=submit],button[type=submit]').prop('disabled', true)

  // Enable submit button again if new input is entered
  $('form input, form select, form textarea').on('input change', function () {
    $(this).parents('form').find('.single-click,input[type=submit]').prop('disabled', false)
  })
}
$(() => {
  $('form').on('submit', function () {
    disableOnSubmit($(this))
  })
})

$('form').bind('invalid-form.validate', function (form, validator) {
  // Remove loading
  $(this).find('.preloader').remove()
  // Enable the submit button (will be disabled on form submit)
  $(this).find('.single-click,input[type=submit]').prop('disabled', false)
})

// Smooth scroll to anchor + adjust top position for fixed navbar
if (window.location.hash) scroll(0, 0)
setTimeout(() => {
  scroll(0, 0)
}, 1)

/**
 * Determine if provided URI is same (or ending in the same) as current location URI
 * @param uri
 * @returns {boolean}
 */
window.isCurrentUrl = function (uri) {
  if (!uri || uri == location.href.split('#')[0] || location.href.split('#')[0].endsWith(uri)) {
    return true
  }
  return false
}

$(() => {
  // Do it for hash-links on same page
  $(document).on('click', 'a', function (event) {
    const ahref = $.attr(this, 'href')
    if ($(this).hasClass('noscroll')) {
      return
    }
    if (!ahref || ahref === '#') {
      event.preventDefault()
      return false
    }
    const link_uri = ahref.split('#')[0]
    const hash = `#${ahref.split('#')[1]}`
    if (isCurrentUrl(link_uri)) {
      event.preventDefault()
      // Change hash for page-reload
      setTimeout(() => {
        window.location.hash = event.target.hash
      }, 200)

      if ($(hash).length) {
        $('html, body').animate(
          {
            scrollTop: $(hash).offset().top - 90,
          },
          500,
        )
      }
    }
  })

  // Do the same when landing on the page - Except for dialog messages
  if (window.location.hash && !window.location.hash.match('message')) {
    // smooth scroll to the anchor id
    let { hash } = window.location
    hash = hash.replace(/[^a-zA-Z0-9\-_]/g, '') // Remove unwanted characters that might break jquery
    const $el = $(hash)
    if ($el.length) {
      animate
    }
  }
})

// Handle numeric input fields that allows for comma as decimal sep
$('body').on('input', 'input.numeric', function () {
  let str = $(this).val()
  str = str.replace(/[^0-9,]/g, '')
  // Make sure only 1 comma for decimals
  let n_comma = 0
  str = str
    .split('')
    .filter((x) => {
      if (x == ',') {
        n_comma++
        return n_comma <= 1 // Return false if n is 2+
      }
      return true
    })
    .join('')
  $(this).val(str)
})

$('body').on('input', 'input.hours', function () {
  let str = $(this).val()
  str = str.replace(/[^0-9.,]/g, '')
  str = str.replace(/,/g, '.')
  // Make sure only 1 comma / decimal point
  // and two chars post-decimal
  let decimal_exists = false
  let n_decimal_places = 0
  str = str
    .split('')
    .filter((x) => {
      // Only allow one decomal/comma
      if (x == ',' || x == '.') {
        if (decimal_exists) {
          // already exists so dont return another one
          return false
        }
        decimal_exists = true
      } else {
        // deal with non decimal/comma chars
        if (decimal_exists) {
          n_decimal_places++
        }
        if (n_decimal_places > 2) {
          return false
        }
      }
      return true
    })
    .join('')
  $(this).val(str)
})

// Handle integer input fields
$('body').on('input', 'input.integer', function () {
  let str = $(this).val()
  str = str.replace(/(,[0-9]+)/g, '')
  str = str.replace(/[^0-9]/g, '')
  $(this).val(str)
})

// Auto-calc the hour_rate incl. fee
$('.hour_rate-input').on('input change', function () {
  if ($(this).data('hour_rate_total_destination')) {
    var dest = $(this).data('hour_rate_total_destination')
  } else {
    var dest = $('.hour_rate-total')
  }
  $(dest).text(Math.round($(this).val() * (1 / (1 - constantsGlobalVar.fee))))
})
$('.jobrate-input').on('input change', function () {
  if ($(this).data('jobrate_excl_destination')) {
    var dest = $(this).data('jobrate_excl_destination')
  } else {
    var dest = $('.jobrate-excl')
  }
  $(dest).text(Math.round($(this).val() * (1 - constantsGlobalVar.fee)))
  $('.jobrate').text($(this).val())
})
// Make sure to trigger on page load to ensure adjustment for browser stored values
$('.jobrate-input, .hour_rate-input').trigger('input')

// Add asterix on required fields
window.fixasterixs = function () {
  $('span.required-asterix').each(function () {
    const input = $(this).next()
    if ($(this).is(':visible')) {
      let leftpx = $(input).outerWidth() + 5
      const offset = $(input).position()
      if (offset) {
        const toppx = offset.top + 10
        leftpx += offset.left
        $(this).css({ top: toppx })
        $(this).css({ left: leftpx })
      }
    }
  })
}

// Things to do on window resize:
window.onresize = function () {
  fixasterixs()
  // TODO: Use some throttle or debounce acc. to http://stackoverflow.com/a/9828919
}

window.unsaved = false
window.alertunsaved = function () {
  $(':input').change(function () {
    // triggers change in all input fields including text type
    const ignoreUnsaved =
      $(this).parents('form').data('ignore-unsaved') == true ||
      typeof $(this).parents('form').data('ignoreUnsaved') !== 'undefined' // for use without a value
    if (!ignoreUnsaved) {
      window.unsaved = true
    }
  })
  $('input[type=submit],.submit-button').on('click', () => {
    window.unsaved = false
  })
  function unloadPage() {
    if (window.unsaved) {
      return $t(
        'You have entered or changed data on this page. Do you want to continue without saving?',
      )
    }
  }
  window.onbeforeunload = unloadPage
}

window.skillsCollapse = function () {
  $('.skills').each(function () {
    $(this).find('.label:gt(2)').removeClass('label-default bgm-purple').addClass('label-basic')
    const num_skills = $(this).find('.label').length
    if (num_skills > 6) {
      const num_hidden = num_skills - 5
      $(this).find('.label:gt(4)').hide()
      $(this)
        .find('.label:eq(5)')
        .after(
          `<a href="#" class="label label-default" onclick="$(this).siblings().show(); $(this).hide(); return false;">+ ${num_hidden} ${$t(
            'more',
          )}</a>`,
        )
    }
  })
}

window.checkFileSize = function (inputid, max_file_size_mb) {
  const input = document.getElementById(inputid)
  // check for browser support (may need to be modified)
  if (input.files && input.files.length == 1) {
    const max_file_size = max_file_size_mb * 1024 * 1024
    if (input.files[0].size > max_file_size) {
      // TODO: Change this to a proper validation error
      alert(`${$t('The file cannot be larger than')} ${max_file_size_mb}MB`)
      return false
    }
  }
  return true
}

window.preventEnterSubmit = function (e) {
  if (e.which == 13) {
    const $targ = $(e.target)

    if (!$targ.is('textarea') && !$targ.is(':button,:submit')) {
      let focusNext = false
      $(this)
        .find(':input:visible:not([disabled],[readonly]), a')
        .each(function () {
          if (this === e.target) {
            focusNext = true
          } else if (focusNext) {
            $(this).focus()
            return false
          }
        })
      return false
    }
  }
}

if (!$.cookie('warn_if_contact_displayed')) {
  $.cookie('warn_if_contact_displayed', 'false')
}

const warn_if_contact_displayed = null

$('.warn-if-contact').keyup(function () {
  const warn_if_contact_displayed = $.cookie('warn_if_contact_displayed')
  if (warn_if_contact_displayed == 'false') {
    $(this)
      .popover({
        trigger: 'manual',
        placement: 'top',
        title: $t('Remember that...'),
        html: true,
        content: `${$t(
          'Communication outside of Worksome is allowed, but the contract should be completed on Worksome :-)',
        )}<br><a href="#" class="btn btn-success iblock m-t-10 btn-sm">OK</a>`,
        template:
          '<div class="popover top" style="margin-top: -16px;"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content c-black" style="padding: 10px;"></div></div>',
      })
      .data('bs.popover')
      .tip()
      .addClass('pointer') // Hack for adding class
    const message = $(this).val()
    const words = constantsGlobalVar.contact_words_list
    const regex_from_php = constantsGlobalVar.contact_regex
    const prepared_regex = `\\b(${words.join('|')})\\b` + `|${regex_from_php.join('|')}`
    const rgx = new RegExp(prepared_regex, 'ig')
    if (rgx.test(message)) {
      if (!$(this).next('div.popover:visible').length) {
        $(this).popover('show')
        $('.popover').click(function () {
          $(this).remove()
          $.cookie('warn_if_contact_displayed', 'true', { expires: 30 })
          const warn_if_contact_displayed = $.cookie('warn_if_contact_displayed')
        })
      }
    } else {
      $(this).popover('hide')
    }
  }
})

window.bytesToSize = function (bytes) {
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
  if (bytes == 0) return '0 Byte'
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)))
  return `${Math.round(bytes / Math.pow(1024, i), 2)} ${sizes[i]}`
}


window.addEventListener('load', () => {
  autosize($('textarea'))
    // Handle a tags with missing href values to prevent page reload
    $('body').on('click', "a[href='']", (e) => {
      e.preventDefault()
    })

    // Handle the issue with missing height on "waves effect"
    $('.btn.waves-effect:visible').height(function () {
      return $(this).height()
    })
    $(document).on('shown.bs.modal', (e) => {
      $('.btn.waves-effect:visible').height(function () {
        return $(this).height()
      })
    })

  $(
    '.form-group input[required=required], .form-group textarea[required=required], .form-group select[required=required]',
  ).each(function () {
    $(this).before('<span class="required-asterix">*</span>')
    fixasterixs()
    setTimeout(() => {
      // Fix post-render
      fixasterixs()
    }, 500)
  })

  // Prevent number fields from changing value on scroll
  $(':input[type=number]').on('mousewheel', function (e) {
    $(this).blur()
  })
})


window.allowEmail = function (eStr) {
  const emails = constantsGlobalVar.freemail_hosts // should be in a different file

  for (let i = 0; i < emails.length; i++) {
    const r = new RegExp(`^(.*?(@${emails[i]}\.)[^$]*)$`, 'g')
    if (r.test(eStr)) {
      return false // We found a match
    }
  }

  return true // We found the email to be allowed
}

window.warnEmailDomain = function (email) {
  const emailDomainValid = allowEmail(email)
  if (!emailDomainValid && !$.cookie('has_warned_about_email')) {
    window.swal(
      {
        title: $t('Have you filled in your\ncompany email?'),
        text: `${$t(
          "We've recognized that your email belongs to a standard email provider.",
        )}\n\n${$t(
          'We recommend that you update with your company email instead - e.g. name@mycompany.com.',
        )} :-)`,
        confirmButtonColor: '#DD6B55',
        confirmButtonText: $t('I understand'),
        closeOnConfirm: true,
      },
      () => {
        $.cookie('has_warned_about_email', true)
      },
    )
    return false
  }
  return true
}
